<script>
import mixinComponent from '../../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../../Mixins/global'

export default {
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    title: String,
    titleT: String,
    titleLevel: { type: [Number, String], default: 4 },
    bordered: { type: Boolean, default: false },
    shadowed: { type: Boolean, default: false },
    hoverShadow: { type: Boolean, default: false },
    transparent: { type: Boolean, default: false },
    classHeader: { type: String, default: '' },
    classBody: { type: String, default: '' },
    classFooter: { type: String, default: '' },
  },

  computed: {
    titleComputed() {
      if (this.titleT) {
        return this.$t(this.titleT)
      }
      return this.title
    },

    isFooter() {
      return this.$slots.footer
    },
  },
}
</script>
<template>
  <div
    :class="
      'card' +
      (bordered ? ' card-bordered' : '') +
      (shadowed ? ' card-shadowed' : '') +
      (hoverShadow ? ' card-hover-shadow' : '') +
      (transparent ? ' card-transparent' : '')
    "
  >
    <header v-if="titleComputed" :class="'card-header ' + classHeader">
      <h2 v-if="titleLevel === 2" class="card-title" v-html="titleComputed"></h2>
      <h3 v-if="titleLevel === 3" class="card-title" v-html="titleComputed"></h3>
      <h4 v-if="titleLevel === 4" class="card-title" v-html="titleComputed"></h4>
      <h5 v-if="titleLevel === 5" class="card-title" v-html="titleComputed"></h5>
    </header>
    <div :class="'card-body ' + classBody">
      <slot></slot>
    </div>
    <footer v-if="isFooter" :class="'card-footer ' + classFooter">
      <slot name="footer"></slot>
    </footer>
  </div>
</template>
